const enum UserExperienceLevel {
  BEGINNER = 'beginner',
  REGULAR = 'regular',
  EXPERIENCED = 'experienced',
  HIGHLY_EXPERIENCED = 'highly_experienced',
}

export { UserExperienceLevel };
